import { LOAD_COMPLAINT, LOAD_SELECT_COMPLAINTS } from './types'
import { IComplaintActions, IComplaintPayload, IComplaintsPayload } from './actions'
import { ILoadingAndFailure } from '../../types/interfaces'

export const initState = {
	complaints: {
		originalData: [],
		tableData: [],
		pagination: null,
		isLoading: false,
		isFailure: false
	} as IComplaintsPayload & ILoadingAndFailure,
	detail: {
		data: null,
		isLoading: false,
		isFailure: false
	} as IComplaintPayload & ILoadingAndFailure
}

export default (state = initState, action: IComplaintActions) => {
	switch (action.type) {
		case LOAD_SELECT_COMPLAINTS.START:
			return {
				...state,
				complaints: {
					...state.complaints,
					isFailure: false,
					isLoading: true
				}
			}
		case LOAD_SELECT_COMPLAINTS.DONE:
			return {
				...state,
				complaints: {
					...initState.complaints,
					...action.payload
				}
			}
		case LOAD_SELECT_COMPLAINTS.FAILED:
			return {
				...state,
				complaints: {
					...initState.complaints,
					isFailure: true
				}
			}

		case LOAD_COMPLAINT.START:
			return {
				...state,
				detail: {
					...state.detail,
					isLoading: true,
					isFailure: false
				}
			}
		case LOAD_COMPLAINT.DONE:
			return {
				...state,
				detail: {
					data: action.payload.data,
					isLoading: false,
					isFailure: false
				}
			}
		case LOAD_COMPLAINT.FAILED:
			return {
				...state,
				detail: {
					...state.detail,
					isLoading: false,
					isFailure: true
				}
			}

		default:
			return state
	}
}
